<div class="pointer" *ngIf="productLayoutType==0" class="product-item product-elevat ext-center">
  <div fxLayout="row" fxLayoutAlign="space-between center" style="position: sticky;z-index: 10;">
    <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
      [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
      [configproduct]="config " style="position: absolute; top: 0; left: 0" [type]="'wishonly'">
    </calsoft-controls>

    <div class="sale-label" style="z-index: 1000;" *ngIf="discountPercentage > 0 && discountPercentage < 100">

      {{ discountPercentage | dynamicRound}}% Off
    </div>
  </div>

  <div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <calsoft-image-lazy-loading *ngIf="showAnimation"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [width]="width" [imageType]="imageType" [heightMobile]="heightMobile"
        [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer" [name]="name" [image]="image">
      </calsoft-image-lazy-loading>


      <calsoft-image-lazy-main-mouse-over-main *ngIf="!showAnimation" [type]="type"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [qty]="qty" [product]="product" [width]="width" [imageType]="imageType"
        [heightMobile]="heightMobile" [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer"
        [name]="name" [list]="list"></calsoft-image-lazy-main-mouse-over-main>

    </div>
    <span *ngIf="product['type']!='Course'">
      <span *ngIf="this.product.type!='Booking'">
        <div *ngIf="outofstockEnabled==1">
          <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
            fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
            <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
          </div>
        </div>
      </span>
    </span>



  </div>
  <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

    <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
      <div fxLayout="row">


        <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

          <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

        </div>
        <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>

    </div>



    <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">


      <div fxLayout="row">
        <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
          [type]="'productsNew'"></calsoft-translator>
        <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>
    </div>



  </div>


  <!-- <div [ngClass]="{
      padinf:
        configurableProductObject['type'] == 'Configurable' &&
        configurableProductObject['configurableProductDropdown'] != null
    }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <calsoft-star-rate [averageRating]="averageRating" [calculateAvgRating]="calculateAvgRating">
    </calsoft-star-rate>
  </div> -->
  <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
    style="padding-bottom: 20px"></div>

  <div *ngIf="showConfigurableDropdown == 1">

    <ng-container *ngIf="!showNewConfig; else newconfig">
      <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
      configurationDropDownList | keyvalue">
        <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{ item.key.replace('_', ' ') }}
          </mat-label>
          <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
            (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
            [formControl]="dropDownValue">
            <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
              {{ object | splitbyHash }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-template #newconfig>

      <div class="padding-rl10 A" fxLayout="row">
        <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{configurationDropDownList[0].key}}
          </mat-label>
          <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
            <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
              *ngFor="let item of configurationDropDownList;let i=index;">
              {{item.value}}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>

      <div class="padding-rl10 A" fxLayout="row">
        <mat-form-field style="
        font-size: 10px;
        height: 54px;
        padding: 0px;
        margin: 0px;
        padding-bottom: 0px;
      " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{configurationDropDownList[0]
            ['recursuive'][0].key}}

          </mat-label>
          <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
              .recursuive[secondIndex].value" [disableOptionCentering]="true">
            <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')" [value]="item1.value"
              *ngFor="let item1 of configurationDropDownList[firstIndex]
       ['recursuive'];let j=index;">
              {{item1.value}}
            </mat-option>
          </mat-select>


        </mat-form-field>
      </div>


    </ng-template>
  </div>

  <div *ngIf="this.data.disablePrice==0">
    <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
      <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
        fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

        <span *ngIf="displayMrpPrice">
          <span *ngIf="specialPrice > 0 && specialPrice != price">
            <b>MRP :</b>
            <span class="old-price text-strike text-muted font-16px">
              {{ price | currencyConvert }}{{units}}
            </span>
          </span>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
          <span *ngIf="displayMrpPrice">
            <b>MRP :</b>
          </span>
          <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
          <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
        </span>

        <span *ngIf="!displayMrpPrice">
          <span *ngIf="specialPrice > 0 && specialPrice != price" class="old-price text-strike text-muted font-16px">
            {{ price | currencyConvert }}{{units}}
          </span>
        </span>



      </div>

      <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
        fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

        <span *ngIf="specialPrice > 0 && specialPrice != price">
          <b *ngIf="displayMrpPrice">MRP :</b>
          <span class="old-price text-strike text-muted font-16px">
            {{ price | currencyConvert }}{{units}}
          </span>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
          <span *ngIf="displayMrpPrice">
            <b>MRP :</b>
          </span>
          <b> {{ price | currencyConvert }}{{units}}</b>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
          <b> {{ specialPrice | currencyConvert }}{{units}}</b>
          <span *ngIf="displayMrpPrice">
            (incl. of tax)
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="padding-lr10"
    [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
    <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
      [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
      [configproduct]="config " [showCartIcon]="showCartIcon" [showCartIncremented]="showCartIncremented">
    </calsoft-controls>


  </div>
</div>


<div class="product-item product-elevat ext-center" *ngIf="productLayoutType==1">
  <div class="img-wrapper">

    <div class="pointer" class="product-item product-elevat ext-center">
      <div fxLayout="row" fxLayoutAlign="space-between center" style="position: sticky;">


        <div class="sale-label" *ngIf="discountPercentage > 0 && discountPercentage < 100">
          {{ discountPercentage | dynamicRound}}% Off
        </div>
      </div>
      <div class="front lable-block" fxLayoutAlign="center center">
        <a [ngClass]="{ 'collection-banner': !radius }">

          <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100"
            [style.border-radius]="radius" [alt]="name"
            [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
            class="padding-10" (click)="productShow(product)"
            [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
            [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
            [name]="name" [image]="image" class="pointer" [name]="name">


        </a>
        <span *ngIf="product['type']!='Course'">
          <span *ngIf="this.product.type!='Booking'">
            <div *ngIf="outofstockEnabled==1">
              <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
                fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
                <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
              </div>
            </div>
          </span>
        </span>

      </div>

      <ul class="product-thumb-list overflowImage">
        <li class="grid_thumb_img" [class.active]="ImageSrc == image" *ngFor="let image of imageListArray; let i=index">
          <a href="javascript:void(0)" (mouseover)="ChangeVariantsImage(image)">

            <span *ngIf="image.includes('commonimages')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';"
                [src]="serverPath7+image | safe: 'resourceUrl'">
            </span>
            <span *ngIf="image.includes('http')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image | safe: 'resourceUrl'">
            </span>
            <span *ngIf="image.includes('medicineimages')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';"
                [src]="commonImageApi+image | safe: 'resourceUrl'">
            </span>
            <span *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';"
                [src]="bigImage+image | safe: 'resourceUrl'">
            </span>

          </a>
        </li>
      </ul>

      <div class="cart-info cart-wrap">


        <a title="Add to cart">
          <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
            [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
            [configproduct]="config " [type]="'cartIcon'" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented">
          </calsoft-controls>
        </a>

        <a *ngIf="product['type'] != 'Course' && product['type'] != 'Variants Subscription'" title="Wishlist">
          <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
            [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
            [configproduct]="config" [type]="'newWishIcon'">
          </calsoft-controls>
        </a>

      </div>


    </div>
    <div class="product-detail">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
      padinf:
        configurableProductObject['type'] == 'Configurable' &&
        configurableProductObject['configurableProductDropdown'] != null
    }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
      configurationDropDownList | keyvalue">
            <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
        font-size: 10px;
        height: 54px;
        padding: 0px;
        margin: 0px;
        padding-bottom: 0px;
      " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
              .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
       ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="margin-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="product-item  ext-center" *ngIf="productLayoutType==2">

  <div class="product">
    <figure class="product-media">

      <a [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [style.border-radius]="radius"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>

      <div class="product-action-vertical">

        <a title="Wishlist">
          <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
            [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
            [configproduct]="config " [type]="'newWishIcon'">
          </calsoft-controls>
        </a>
      </div>


      <div class="product-action">
        <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
          [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
          [configproduct]="config " [type]="'newAddTocart'" [showCartIcon]="showCartIcon"
          [showCartIncremented]="showCartIncremented">
        </calsoft-controls>
      </div>
    </figure>

    <div class="product-details">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
        padinf:
          configurableProductObject['type'] == 'Configurable' &&
          configurableProductObject['configurableProductDropdown'] != null
      }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
        fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
        configurationDropDownList | keyvalue">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
          font-size: 10px;
          height: 54px;
          padding: 0px;
          margin: 0px;
          padding-bottom: 0px;
        " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
         ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="product-item  ext-center" *ngIf="productLayoutType==3">

  <div class="product images">
    <figure class="product-media">


      <a [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ 'collection-banner': !radius }"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>


    </figure>

    <div class="product-body text-center">
      <div class="product-details">
        <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row"
          fxLayoutAlign="start center">

          <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
            [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
            <div fxLayout="row">
              <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

                <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

              </div>
              <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px"
                *ngIf="prescriptionRequired" alt="prescriptionRequired">
            </div>

          </div>

          <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
            [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
            <div fxLayout="row">
              <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
                [type]="'productsNew'"></calsoft-translator>
              <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
                alt="prescriptionRequired">
            </div>
          </div>



        </div>


        <div [ngClass]="{
          padinf:
            configurableProductObject['type'] == 'Configurable' &&
            configurableProductObject['configurableProductDropdown'] != null
        }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
          fxLayoutGap="10px">
          <div class="review-Rating E_uFuv">
            {{ calculateAvgRating | number: "1.1-1" }}

            <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
          </div>
          <div>
            &#40;<span>{{ averageRating }}</span>&#41;
          </div>
        </div>
        <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
          style="padding-bottom: 20px"></div>

        <div *ngIf="showConfigurableDropdown == 1">

          <ng-container *ngIf="!showNewConfig; else newconfig">
            <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
          configurationDropDownList | keyvalue">
              <mat-form-field style="
                font-size: 10px;
                height: 54px;
                padding: 0px;
                margin: 0px;
                padding-bottom: 0px;
              " appearance="outline" fxFlex="100">
                <mat-label style="font-size: 12px">
                  {{ item.key.replace('_', ' ') }}
                </mat-label>
                <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                  (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                  [formControl]="dropDownValue">
                  <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                    {{ object | splitbyHash }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-template #newconfig>

            <div class="padding-rl10 A" fxLayout="row">
              <mat-form-field style="
                font-size: 10px;
                height: 54px;
                padding: 0px;
                margin: 0px;
                padding-bottom: 0px;
              " appearance="outline" fxFlex="100">
                <mat-label style="font-size: 12px">
                  {{configurationDropDownList[0].key}}
                </mat-label>
                <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                  <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')"
                    [value]="item.value" *ngFor="let item of configurationDropDownList;let i=index;">
                    {{item.value}}
                  </mat-option>
                </mat-select>

              </mat-form-field>
            </div>

            <div class="padding-rl10 A" fxLayout="row">
              <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
                <mat-label style="font-size: 12px">
                  {{configurationDropDownList[0]
                  ['recursuive'][0].key}}

                </mat-label>
                <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                  .recursuive[secondIndex].value" [disableOptionCentering]="true">
                  <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                    [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
           ['recursuive'];let j=index;">
                    {{item1.value}}
                  </mat-option>
                </mat-select>


              </mat-form-field>
            </div>


          </ng-template>
        </div>

        <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
          <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
            <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
              fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

              <span *ngIf="displayMrpPrice">
                <span *ngIf="specialPrice > 0 && specialPrice != price">
                  <b>MRP :</b>
                  <span class="old-price text-strike text-muted font-16px">
                    {{ price | currencyConvert }}{{units}}
                  </span>
                </span>
              </span>

              <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
                <span *ngIf="displayMrpPrice">
                  <b>MRP :</b>
                </span>
                <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
              </span>

              <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
                <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
              </span>

              <span *ngIf="!displayMrpPrice">
                <span *ngIf="specialPrice > 0 && specialPrice != price"
                  class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>



            </div>

            <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)"
              class="pointer padding-rl10" fxLayout="row" fxLayoutGap="10px"
              fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b *ngIf="displayMrpPrice">MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>

              <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
                <span *ngIf="displayMrpPrice">
                  <b>MRP :</b>
                </span>
                <b> {{ price | currencyConvert }}{{units}}</b>
              </span>

              <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
                <b> {{ specialPrice | currencyConvert }}{{units}}</b>
                <span *ngIf="displayMrpPrice">
                  (incl. of tax)
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>


      <div style="margin-bottom: 10px;" class="product-action">

        <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
          [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
          [configproduct]="config " [type]="'type4addtocart'" [showCartIcon]="showCartIcon"
          [showCartIncremented]="showCartIncremented">
        </calsoft-controls>

      </div>
    </div>
  </div>
</div>

<div class="product-item  ext-center" *ngIf="productLayoutType==4">

  <div class="product">
    <figure class="product-media">

      <a [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [style.border-radius]="radius"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>

      <div class="product-action-vertical">

        <a title="Wishlist">
          <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
            [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
            [configproduct]="config " [type]="'newWishIcon'">
          </calsoft-controls>
        </a>
      </div>


      <div class="product-action2">
        <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
          [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
          [configproduct]="config " [type]="'newAddTocart'" [showCartIcon]="showCartIcon"
          [showCartIncremented]="showCartIncremented">
        </calsoft-controls>
      </div>
    </figure>

    <div class="product-details">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
        padinf:
          configurableProductObject['type'] == 'Configurable' &&
          configurableProductObject['configurableProductDropdown'] != null
      }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
        fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
        configurationDropDownList | keyvalue">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
          font-size: 10px;
          height: 54px;
          padding: 0px;
          margin: 0px;
          padding-bottom: 0px;
        " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
         ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="product-item  ext-center" *ngIf="productLayoutType==5">

  <div class="product">
    <figure class="product-media">

      <a [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>


      <div class="product-action-vertical1 product-action_2">

        <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
          [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
          [configproduct]="config " [type]="'type5addtocart'">
        </calsoft-controls>

      </div>



    </figure>

    <div class="product-details">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
        padinf:
          configurableProductObject['type'] == 'Configurable' &&
          configurableProductObject['configurableProductDropdown'] != null
      }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
        fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
        configurationDropDownList | keyvalue">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
          font-size: 10px;
          height: 54px;
          padding: 0px;
          margin: 0px;
          padding-bottom: 0px;
        " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
         ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="product-item  ext-center" *ngIf="productLayoutType==6">

  <div class="product">
    <figure class="product-media ">

      <a [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)" class="imgbkg">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer ">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>

      <div class="product-action3">
        <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
          [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
          [configproduct]="config " [type]="'type5addtocart'">
        </calsoft-controls>
      </div>

    </figure>
    <div class="product-details">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
        padinf:
          configurableProductObject['type'] == 'Configurable' &&
          configurableProductObject['configurableProductDropdown'] != null
      }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
        fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
        configurationDropDownList | keyvalue">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
          font-size: 10px;
          height: 54px;
          padding: 0px;
          margin: 0px;
          padding-bottom: 0px;
        " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
         ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
<div class="product-item product-elevat ext-center" *ngIf="productLayoutType==7">
  <div class="img-wrapper">

    <div class="pointer" class="product-item product-elevat ext-center">
      <div fxLayout="row" fxLayoutAlign="space-between center" style="position: sticky;">


        <div class="sale-label" *ngIf="discountPercentage > 0 && discountPercentage < 100">
          {{ discountPercentage | dynamicRound}}% Off
        </div>
      </div>
      <div class="front lable-block" fxLayoutAlign="center center">
        <a [ngClass]="{ 'collection-banner': !radius }">

          <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
            [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
            class="padding-10" (click)="productShow(product)"
            [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
            [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
            [name]="name" [image]="image" class="pointer" [name]="name">


        </a>
        <span *ngIf="product['type']!='Course'">
          <span *ngIf="this.product.type!='Booking'">
            <div *ngIf="outofstockEnabled==1">
              <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
                fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
                <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
              </div>
            </div>
          </span>
        </span>

      </div>

      <!-- <ul class="product-thumb-list overflowImage">
        <li class="grid_thumb_img" [class.active]="ImageSrc == image" *ngFor="let image of imageListArray; let i=index">
          <a href="javascript:void(0)" (mouseover)="ChangeVariantsImage(image)">

            <span *ngIf="image.includes('commonimages')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';"
                [src]="serverPath7+image | safe: 'resourceUrl'">
            </span>
            <span *ngIf="image.includes('http')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';"
                [src]="image | safe: 'resourceUrl'">
            </span>
            <span *ngIf="image.includes('medicineimages')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';"
                [src]="commonImageApi+image | safe: 'resourceUrl'">
            </span>
            <span *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')">
              <img onerror="this.src='assets/images/products/placeholder.jpg';"
                [src]="bigImage+image | safe: 'resourceUrl'">
            </span>

          </a>
        </li>
      </ul> -->

      <div class="cart-info cart-wrap">


        <a title="Add to cart">
          <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
            [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
            [configproduct]="config " [type]="'cartIcon'" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented">
          </calsoft-controls>
        </a>

        <a title="Wishlist">
          <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
            [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
            [configproduct]="config " [type]="'newWishIcon'">
          </calsoft-controls>
        </a>
      </div>


    </div>
    <div class="product-detail">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
      padinf:
        configurableProductObject['type'] == 'Configurable' &&
        configurableProductObject['configurableProductDropdown'] != null
    }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
      configurationDropDownList | keyvalue">
            <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
        font-size: 10px;
        height: 54px;
        padding: 0px;
        margin: 0px;
        padding-bottom: 0px;
      " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
              .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
       ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="margin-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="product-item  ext-center" *ngIf="productLayoutType==8">

  <div class="product">
    <figure class="product-media">

      <a [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>

      <div class="product-action-vertical1 product-action_3">

        <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
          [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
          [configproduct]="config " [type]="'type5addtocart'">
        </calsoft-controls>

      </div>



    </figure>

    <div class="product-details">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
        padinf:
          configurableProductObject['type'] == 'Configurable' &&
          configurableProductObject['configurableProductDropdown'] != null
      }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
        fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
        configurationDropDownList | keyvalue">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
          font-size: 10px;
          height: 54px;
          padding: 0px;
          margin: 0px;
          padding-bottom: 0px;
        " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
         ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="pointer" *ngIf="productLayoutType==9" class="product-item product-elevat ext-center">
  <div fxLayout="row" fxLayoutAlign="space-between center" style="position: sticky;">
    <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
      [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
      [configproduct]="config " style="position: absolute; top: 0; left: 0" [type]="'wishonly'">
    </calsoft-controls>

    <div class="sale-label" *ngIf="discountPercentage > 0 && discountPercentage < 100">
      {{ discountPercentage | dynamicRound}}% Off
    </div>
  </div>

  <div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <calsoft-image-lazy-loading *ngIf="showAnimation" [radius]="'12px'"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [width]="width" [imageType]="imageType" [heightMobile]="heightMobile"
        [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer" [name]="name" [image]="image">
      </calsoft-image-lazy-loading>


      <calsoft-image-lazy-main-mouse-over-main *ngIf="!showAnimation" [type]="type"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [qty]="qty" [product]="product" [width]="width" [imageType]="imageType"
        [heightMobile]="heightMobile" [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer"
        [name]="name" [list]="list"></calsoft-image-lazy-main-mouse-over-main>

    </div>
    <span *ngIf="product['type']!='Course'">
      <span *ngIf="this.product.type!='Booking'">
        <div *ngIf="outofstockEnabled==1">
          <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
            fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
            <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
          </div>
        </div>
      </span>
    </span>



  </div>
  <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

    <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
      <div fxLayout="row">
        <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

          <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

        </div>
        <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>

    </div>

    <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
      <div fxLayout="row">
        <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
          [type]="'productsNew'"></calsoft-translator>
        <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>
    </div>

  </div>

  <div [ngClass]="{
      padinf:
        configurableProductObject['type'] == 'Configurable' &&
        configurableProductObject['configurableProductDropdown'] != null
    }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <div class="review-Rating E_uFuv">
      {{ calculateAvgRating | number: "1.1-1" }}

      <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
    </div>
    <div>
      &#40;<span>{{ averageRating }}</span>&#41;
    </div>
  </div>
  <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
    style="padding-bottom: 20px"></div>

  <div *ngIf="showConfigurableDropdown == 1">

    <ng-container *ngIf="!showNewConfig; else newconfig">
      <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
      configurationDropDownList | keyvalue">
        <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{ item.key.replace('_', ' ') }}
          </mat-label>
          <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
            (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
            [formControl]="dropDownValue">
            <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
              {{ object | splitbyHash }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-template #newconfig>

      <div class="padding-rl10 A" fxLayout="row">
        <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{configurationDropDownList[0].key}}
          </mat-label>
          <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
            <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
              *ngFor="let item of configurationDropDownList;let i=index;">
              {{item.value}}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>

      <div class="padding-rl10 A" fxLayout="row">
        <mat-form-field style="
        font-size: 10px;
        height: 54px;
        padding: 0px;
        margin: 0px;
        padding-bottom: 0px;
      " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{configurationDropDownList[0]
            ['recursuive'][0].key}}

          </mat-label>
          <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
              .recursuive[secondIndex].value" [disableOptionCentering]="true">
            <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')" [value]="item1.value"
              *ngFor="let item1 of configurationDropDownList[firstIndex]
       ['recursuive'];let j=index;">
              {{item1.value}}
            </mat-option>
          </mat-select>


        </mat-form-field>
      </div>


    </ng-template>
  </div>

  <div fxLayout="row" style="padding-bottom: 10px;">
    <div fxFlex="100" style="padding-left: 12px;padding-bottom: 5px;">

      <div fxFlex="100" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">


          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>
          </div>

          <div *ngIf="!inclTaxEnabled" (click)="productShow(product)">
            <div>
              <div *ngIf="specialPrice > 0 && specialPrice != price">
                <b *ngIf="displayMrpPrice">MRP :</b>
                <p class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </p>
              </div>

              <div class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
                <p *ngIf="displayMrpPrice">
                  <b>MRP :</b>
                </p>
                <b> {{ price | currencyConvert }}{{units}}</b>
              </div>

              <div class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
                <b> {{ specialPrice | currencyConvert }}{{units}}</b>
                <span *ngIf="displayMrpPrice">
                  (incl. of tax)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>


  <div fxLayout="row" class="padding-10" fxLayoutAlign="space-between center" style="padding-bottom: 10px;">
    <div fxFlex="48">
      <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
        <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
          [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
          [type]="'cartIcon'" [configproduct]="config " [showCartIcon]="showCartIcon"
          [showCartIncremented]="showCartIncremented">
        </calsoft-controls>
      </div>

      <div fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">

        <mat-icon [style.color]="data.carouselIconColor">remove_shopping_cart</mat-icon>

      </div>
    </div>

    <div fxFlex="45" fxFlex.lt-md="0">
      <button mat-button fxFlex="100" (click)="productShow(product)" class="preview-button">Preview</button>
    </div>
  </div>

</div>

<div *ngIf="productLayoutType==10" class="product-item product-elevat ext-center pointer">

  <div class="image">
    <div fxLayout="row" fxLayoutAlign="center center">
      <calsoft-image-lazy-loading *ngIf="showAnimation" [radius]="'12px'"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [width]="width" [imageType]="imageType" [heightMobile]="heightMobile"
        [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer" [name]="name" [image]="image">
      </calsoft-image-lazy-loading>


      <calsoft-image-lazy-main-mouse-over-main *ngIf="!showAnimation" [type]="type"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [qty]="qty" [product]="product" [width]="width" [imageType]="imageType"
        [heightMobile]="heightMobile" [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer"
        [name]="name" [list]="list"></calsoft-image-lazy-main-mouse-over-main>

    </div>
  </div>

  <div style="padding-bottom: 5px;">

  </div>

  <div class="productPrice padding-rl10" fxLayout="row" fxLayoutAlign="start center">

    <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
      <div fxLayout="row">
        <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

          <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

        </div>
        <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>

    </div>

    <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
      <div fxLayout="row">
        <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
          [type]="'productsNew'"></calsoft-translator>
        <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>
    </div>

  </div>

  <div class="productPrice space padding-rl10" (click)="openInNewWindow(MapLink)" fxLayout="row"
    fxLayoutAlign="start center">
    <div *ngIf="Address?.length>0" class="add_main">
      <span><i class="material-icons">location_on</i></span>
      <div class="address_main">
        {{Address}}
      </div>
    </div>
  </div>

  <div class="productPrice space padding-rl10" (click)="openInNewWindow(MapLink)" fxLayout="row"
    fxLayoutAlign="start center">
    <div fxLayout="row" fxLayoutGap="5px" *ngIf="Distance?.length>0" class="add_main">Distance:&#160;
      <div fxLayout="row">
        <span><mat-icon style="font-size:16px ;">flight</mat-icon></span>
        <div style="margin-left:-15px ;">
          {{ flightDistance }}
        </div>
      </div>
      <div fxLayout="row">
        <span><mat-icon style="font-size:16px ;">train</mat-icon></span>
        <div style="margin-left:-15px ;">
          {{ trainDistance }}
        </div>
      </div>
    </div>
  </div>

  <div class="review-section" fxLayout="column" fxLayoutGap="10px">
    <div *ngIf="Custom_Review?.length>0">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutAlign.xs="start start"
        class="review-item">

        <div fxLayout="row" fxLayoutGap="5px" class="stars">
          <img src="assets/logo/Tripadvisor-02.png" alt="Google" class="review-icon">
          <mat-icon *ngFor="let star of getStars(Custom_Review); let i = index" class="star">star</mat-icon>
        </div>
        <span class="review-text">| {{Review_Count}} reviews</span>
      </div>
    </div>

    <div *ngIf="Google_Review?.length>0">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutAlign.xs="start start"
        class="review-item">

        <div fxLayout="row" fxLayoutGap="10px" class="stars">
          <img src="assets/logo/Google.png" alt="Google" class="review-icon">
          <mat-icon *ngFor="let star of getStars2(Google_Review); let i = index" class="star">star</mat-icon>
        </div>
        <span class="review-text">| {{Google_Review_Count}} reviews</span>
      </div>
    </div>

  </div>




  <div class=" productPrice padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
    fxLayoutGap="10px">
    <calsoft-star-rate [averageRating]="averageRating" [calculateAvgRating]="calculateAvgRating">
    </calsoft-star-rate>
  </div>


  <div [ngClass]="{
      padinf:
        configurableProductObject['type'] == 'Configurable' &&
        configurableProductObject['configurableProductDropdown'] != null
    }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <calsoft-star-rate [averageRating]="averageRating" [calculateAvgRating]="calculateAvgRating">
    </calsoft-star-rate>
  </div>

  <div class="productPrice padding-rl10" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="10px">
      <button (click)="dynamicFormPopup()" class="padding-10 addbtn primary" style="color:white" mat-button>Enquiry
      </button>

      <button (click)="productShow(product)" class="padding-10 addbtn primary" style="color:white" mat-button>Explore
      </button>


    </div>

    <div *ngIf="data?.customButtonInCategroyPage; else bookNowSection">
      <div fxLayout="row" class="padding-10" fxLayoutAlign="center center">
        <button fxFlex="100" (click)="PageNavigation(data.customButtonInCategroyPageNavigation)" class="primary"
          style="color: white;" mat-button>
          {{ data?.customButtonInCategroyPage }}
        </button>
      </div>
    </div>

    <ng-template #bookNowSection>
      <div class="padding-lr10"
        [ngClass]="{ overlayProduct: (qty <= 0 || isInStock == 0) && (manageStock == 1 || isInStock == 0) }">
        <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
          [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
          [configproduct]="config" [type]="'booknow'" [showCartIcon]="showCartIcon"
          [showCartIncremented]="showCartIncremented">
        </calsoft-controls>
      </div>
    </ng-template>


  </div>

  <div style="padding-bottom: 5px;">

  </div>


</div>

<div class="pointer" *ngIf="productLayoutType==11" class="product-item product-elevat ext-center">
  <div fxLayout="row" fxLayoutAlign="space-between center" style="position: sticky;">

    <div class="sale-label" *ngIf="discountPercentage > 0 && discountPercentage < 100">
      {{ discountPercentage | dynamicRound}}% Off
    </div>
  </div>

  <div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)"
        [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
        [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
        [name]="name" [image]="image" class="pointer" [name]="name">
    </div>

    <span *ngIf="product['type']!='Course'">

      <span *ngIf="this.product.type!='Booking'">
        <div *ngIf="outofstockEnabled==1">
          <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
            fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
            <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
          </div>
        </div>
      </span>
    </span>
  </div>

  <div class="padding-5">

  </div>

  <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

    <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
      <div fxLayout="row">
        <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

          <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

        </div>
        <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>

    </div>

    <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
      <div fxLayout="row">
        <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
          [type]="'productsNew'"></calsoft-translator>
        <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>
    </div>

  </div>

  <div class="padding-5">

  </div>

  <div *ngIf="this.data.disablePrice==0">
    <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">

      <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
        fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

        <span *ngIf="displayMrpPrice">
          <span *ngIf="specialPrice > 0 && specialPrice != price">
            <b>MRP :</b>
            <span class="old-price text-strike text-muted font-16px">
              {{ price | currencyConvert }}{{units}}
            </span>
          </span>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
          <span *ngIf="displayMrpPrice">
            <b>MRP :</b>
          </span>
          <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
          <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
        </span>

        <span *ngIf="!displayMrpPrice">
          <span *ngIf="specialPrice > 0 && specialPrice != price" class="old-price text-strike text-muted font-16px">
            {{ price | currencyConvert }}{{units}}
          </span>
        </span>



      </div>

      <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
        fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
          <b>Price :</b> <b> {{ price | currencyConvert }}{{units}}</b>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
          <b>Price :</b> <b> {{ specialPrice | currencyConvert }}{{units}}</b>
        </span>
      </div>

    </div>
  </div>

  <div *ngIf="BRANDS?.length>0" class="productPrice space padding-rl10" (click)="productShow(product)" fxLayout="row"
    fxLayoutAlign="start center">
    <div>
      <b>Brand : </b> <b>{{BRANDS}}</b>
    </div>
  </div>

  <!-- <div class="productPrice space padding-rl10" (click)="productShow(product)" fxLayout="row"
    fxLayoutAlign="start center">
    <div>
      <b>Weight : </b> <b>{{weight}}</b>
    </div>
  </div> -->

  <div fxLayout="row" class="padding-10" fxLayoutAlign="center center">
    <button fxFlex="100" (click)="productShow(product)" class="primary" style="color: white;" mat-button>VIEW CATALOG
    </button>
  </div>
</div>

<div class="pointer" *ngIf="productLayoutType==12" class="product-item product-elevat ext-center">

  <div>
    <div fxLayout="row" fxLayoutAlign="center center">

      <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)"
        [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
        [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
        [name]="name" [image]="image" class="pointer" [name]="name">
    </div>
  </div>

  <div class="padding-5">

  </div>

  <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

    <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
      <div fxLayout="row">
        <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

          <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

        </div>
        <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>

    </div>

    <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
      <div fxLayout="row">
        <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
          [type]="'productsNew'"></calsoft-translator>
        <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>
    </div>

  </div>

  <div style="padding-top: 10px;" class="padding-rl10" [innerHTML]="description1">

  </div>

  <div fxLayout="row" class="padding-10" fxLayoutAlign="center center">
    <button fxFlex="100" (click)="productShow(product)" class="primary" style="color: white;" mat-button>{{
      data?.customButtonInCategroyPage || 'View Catalog' }}
    </button>
  </div>
</div>

<div *ngIf="productLayoutType==13" style="border-radius: 30px;" class="product-item product-elevat1 ext-center pointer">

  <div class="padding-10">

    <div class="image">
      <div style="padding-top: 10px;padding: 10px;" fxLayout="row" fxLayoutAlign="center center">

        <img style="border-radius: 15px;" onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image"
          [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer" [name]="name">
      </div>
    </div>

    <div style="padding-bottom: 5px;">

    </div>

    <div class="productPrice padding-rl10" fxLayout="row" fxLayoutAlign="start center">

      <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
        [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" style="margin-bottom: 15px;" fxFlex>
        <div fxLayout="row">
          <div class="truncate-text font" [fxFlex]="prescriptionRequired?96:100">

            <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

          </div>
        </div>

      </div>

      <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
        [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
        <div fxLayout="row">
          <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
            [type]="'productsNew'"></calsoft-translator>
        </div>
      </div>

    </div>

    <div class="productPrice padding-rl10" fxLayout="row" fxLayoutAlign="start center">
      <div *ngIf="propertyType?.length>0" class="add_main">
        <span><i class="material-icons">home</i></span>
        <div class="address_main">
          {{propertyType}}
        </div>
      </div>
    </div>

    <div class="productPrice padding-rl10" (click)="openInNewWindow(MapLink)" fxLayout="row"
      fxLayoutAlign="start center">
      <div class="add_main">
        <span><i class="material-icons">location_on</i></span>
        <div *ngIf="Address?.length>0" class="address_main">
          {{Address}}
        </div>
      </div>
    </div>

    <div class="productPrice padding-rl10" fxLayout="row" fxLayoutAlign="start center">
      <div class="add_main">
        <span><i class="material-icons">money</i></span>
        <div class="address_main">
          {{ price | currencyConvert }}{{units}}
        </div>
      </div>
    </div>

    <div class="productPrice  padding-rl10" fxLayout="row" fxLayoutAlign="start center" style="margin-bottom: 15px;">
      <div *ngIf="rooms?.length>0" class="add_main">
        <span><i class="material-icons">hotel</i></span>
        <div class="address_main">
          {{rooms}}
        </div>
      </div>
    </div>


    <div class="productPrice padding-rl10" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
      <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">

        <button fxFlex="100" (click)="productShow(product)" mat-stroked-button>
          More Details
        </button>


      </div>
    </div>

    <div style="padding-bottom: 5px;">

    </div>

  </div>




</div>

<div class="pointer" *ngIf="productLayoutType==14" class="product-item product-elevat ext-center">
  <div fxLayout="row" fxLayoutAlign="space-between center" style="position: sticky;z-index: 10;">
    <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
      [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
      [configproduct]="config " style="position: absolute; top: 0; left: 0" [type]="'wishonly'">
    </calsoft-controls>

    <div class="sale-label" style="z-index: 1000;" *ngIf="discountPercentage > 0 && discountPercentage < 100">

      {{ discountPercentage | dynamicRound}}% Off
    </div>
  </div>

  <div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <calsoft-image-lazy-loading *ngIf="showAnimation"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [width]="width" [imageType]="imageType" [heightMobile]="heightMobile"
        [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer" [name]="name" [image]="image">
      </calsoft-image-lazy-loading>


      <calsoft-image-lazy-main-mouse-over-main *ngIf="!showAnimation" [type]="type"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }" class="padding-10"
        (click)="productShow(product)" [qty]="qty" [product]="product" [width]="width" [imageType]="imageType"
        [heightMobile]="heightMobile" [widthMobile]="widthMobile" [height]="height" [type]="type" class="pointer"
        [name]="name" [list]="list"></calsoft-image-lazy-main-mouse-over-main>

    </div>
    <span *ngIf="product['type']!='Course'">
      <span *ngIf="this.product.type!='Booking'">
        <div *ngIf="outofstockEnabled==1">
          <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
            fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
            <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
          </div>
        </div>
      </span>
    </span>



  </div>
  <div style="padding-top: 10px;" class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row"
    fxLayoutAlign="start center">

    <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
      <div fxLayout="row">
        <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

          <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

        </div>
        <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>

    </div>

    <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
      [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
      <div fxLayout="row">
        <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
          [type]="'productsNew'"></calsoft-translator>
        <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
          alt="prescriptionRequired">
      </div>
    </div>



  </div>


  <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
    style="padding-bottom: 20px"></div>

  <div *ngIf="showConfigurableDropdown == 1">

    <ng-container *ngIf="!showNewConfig; else newconfig">
      <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
      configurationDropDownList | keyvalue">
        <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{ item.key.replace('_', ' ') }}
          </mat-label>
          <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
            (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
            [formControl]="dropDownValue">
            <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
              {{ object | splitbyHash }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-template #newconfig>

      <div class="padding-rl10 A" fxLayout="row">
        <mat-form-field style="
            font-size: 10px;
            height: 54px;
            padding: 0px;
            margin: 0px;
            padding-bottom: 0px;
          " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{configurationDropDownList[0].key}}
          </mat-label>
          <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
            <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
              *ngFor="let item of configurationDropDownList;let i=index;">
              {{item.value}}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>

      <div class="padding-rl10 A" fxLayout="row">
        <mat-form-field style="
        font-size: 10px;
        height: 54px;
        padding: 0px;
        margin: 0px;
        padding-bottom: 0px;
      " appearance="outline" fxFlex="100">
          <mat-label style="font-size: 12px">
            {{configurationDropDownList[0]
            ['recursuive'][0].key}}

          </mat-label>
          <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
              .recursuive[secondIndex].value" [disableOptionCentering]="true">
            <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')" [value]="item1.value"
              *ngFor="let item1 of configurationDropDownList[firstIndex]
       ['recursuive'];let j=index;">
              {{item1.value}}
            </mat-option>
          </mat-select>


        </mat-form-field>
      </div>


    </ng-template>
  </div>

  <div style="padding-top: 10px;" *ngIf="this.data.disablePrice==0">
    <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
      <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
        fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

        <span *ngIf="displayMrpPrice">
          <span *ngIf="specialPrice > 0 && specialPrice != price">
            <b>MRP :</b>
            <span class="old-price text-strike text-muted font-16px">
              {{ price | currencyConvert }}{{units}}
            </span>
          </span>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
          <span *ngIf="displayMrpPrice">
            <b>MRP :</b>
          </span>
          <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
          <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
        </span>

        <span *ngIf="!displayMrpPrice">
          <span *ngIf="specialPrice > 0 && specialPrice != price" class="old-price text-strike text-muted font-16px">
            {{ price | currencyConvert }}{{units}}
          </span>
        </span>



      </div>

      <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
        fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

        <span *ngIf="specialPrice > 0 && specialPrice != price">
          <b *ngIf="displayMrpPrice">MRP :</b>
          <span class="old-price text-strike text-muted font-16px">
            {{ price | currencyConvert }}{{units}}
          </span>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
          <span *ngIf="displayMrpPrice">
            <b>MRP :</b>
          </span>
          <b> {{ price | currencyConvert }}{{units}}</b>
        </span>

        <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
          <b> {{ specialPrice | currencyConvert }}{{units}}</b>
          <span *ngIf="displayMrpPrice">
            (incl. of tax)
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="padding-lr10"
    [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
    <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
      [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
      [configproduct]="config" [type]="'coursecart'" [showCartIcon]="showCartIcon"
      [showCartIncremented]="showCartIncremented">
    </calsoft-controls>


  </div>
</div>

<div *ngIf="productLayoutType==15" style="border-radius: 10px;margin-bottom: 20px;"
  class="product-item product-elevat1 ext-center pointer">

  <div>
    <div class="property-card">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
        <div class="image-container">
          <owl-carousel-o [options]="customOptions">
            <!-- @for (img of imageListArray; track img;) { -->
            <ng-container *ngFor="img of imageListArray;let i=index;">
              <ng-template carouselSlide>
                <img style="border-top-left-radius: 10px;" onerror="this.src='assets/images/products/placeholder.jpg';"
                  [src]="serverPath7+img" [offset]="100" [alt]="name"
                  [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
                  class="padding-10" (click)="productShow(product)"
                  [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
                  [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
                  [name]="name" [image]="image" class="pointer" [name]="name">
              </ng-template>
            </ng-container>
            <!-- } -->
          </owl-carousel-o>
        </div>

        <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px" class="padding-10">
          <div>
            <div class="productPrice padding-rl10" fxLayout="row" fxLayoutAlign="start center">
              <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
                [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" style="margin-bottom: 15px;" fxFlex>
                <div fxLayout="row">
                  <div class="truncate-text font" [fxFlex]="prescriptionRequired?96:100">

                    <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

                  </div>
                </div>

              </div>

              <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
                [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
                <div fxLayout="row">
                  <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
                    [type]="'productsNew'"></calsoft-translator>
                </div>
              </div>

            </div>

            <div style="padding-top: 10px;" class="padding-rl10">
              <h2 [innerHTML]="shortDescription"></h2>
            </div>

            <div style="padding-top: 10px;" *ngIf="this.data.disablePrice==0">
              <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
                <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)"
                  class="pointer padding-rl10" fxLayout="row" fxLayoutGap="10px"
                  fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

                  <span *ngIf="displayMrpPrice">
                    <span *ngIf="specialPrice > 0 && specialPrice != price">
                      <b>MRP :</b>
                      <span class="old-price text-strike text-muted font-16px">
                        {{ price | currencyConvert }}{{units}}
                      </span>
                    </span>
                  </span>

                  <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
                    <span *ngIf="displayMrpPrice">
                      <b>MRP :</b>
                    </span>
                    <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
                  </span>

                  <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
                    <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
                  </span>

                  <span *ngIf="!displayMrpPrice">
                    <span *ngIf="specialPrice > 0 && specialPrice != price"
                      class="old-price text-strike text-muted font-16px">
                      {{ price | currencyConvert }}{{units}}
                    </span>
                  </span>



                </div>

                <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)"
                  class="pointer padding-rl10" fxLayout="row" fxLayoutGap="10px"
                  fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

                  <span *ngIf="specialPrice > 0 && specialPrice != price">
                    <b *ngIf="displayMrpPrice">MRP :</b>
                    <span class="old-price text-strike text-muted font-16px">
                      {{ price | currencyConvert }}{{units}}
                    </span>
                  </span>

                  <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
                    <span *ngIf="displayMrpPrice">
                      <b>MRP :</b>
                    </span>
                    <b> {{ price | currencyConvert }}{{units}}</b>
                  </span>

                  <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
                    <b> {{ specialPrice | currencyConvert }}{{units}}</b>
                    <span *ngIf="displayMrpPrice">
                      (incl. of tax)
                    </span>
                  </span>
                </div>
              </div>
            </div>

          </div>



          <!-- <div class="productPrice padding-rl10" fxLayout="row" fxLayoutAlign="start center">
            <div class="add_main">
              <span><i class="material-icons">money</i></span>
              <div class="address_main">
                {{ price | currencyConvert }}{{units}}
              </div>
            </div>
          </div> -->
          <div fxLayout="column">

            <div class=" padding-rl10" (click)="openInNewWindow(MapLink)" fxLayout="row" fxLayoutAlign="start center">
              <div class="add_main">
                <span><i class="material-icons">location_on</i></span>
                <div *ngIf="Address?.length>0" class="address_main">
                  {{Address}}
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" class="marginb">
              <div class="borderright padding-rl10" style="border-right: 1px solid black;" fxLayout="row"
                fxLayoutAlign="start center">
                <div *ngIf="propertyType?.length>0" class="add_main">
                  <span><i class="material-icons">home</i></span>
                  <div class="address_main">
                    {{propertyType}}
                  </div>
                </div>
              </div>
              <div class=" padding-rl10" fxLayout="row" fxLayoutAlign="start center">
                <div *ngIf="rooms?.length>0" class="add_main">
                  <span><i class="material-icons">hotel</i></span>
                  <div class="address_main">
                    {{rooms}}
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>

      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" class="secondcontent">
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="start center">

          <div fxFlex="10">
            <img src="assets/icons/Medical Delivery-01.svg" alt="sssss" class="profileimage">
          </div>
          <div fxFlex>
            <p style="margin-top: 0px;">Listed 1 Day Ago</p>
          </div>

        </div>
        <div fxFlex="50" fxFlex.xs="100" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center"
          fxLayoutGap="10px">
          <div fxFlex="30">
            <button fxLayout="row" (click)="callPhone()" fxLayoutAlign="center center" mat-button
              style=" width: 100%; border:1px solid rgb(46, 10, 100);padding: 10px; border-radius: 10px;color: rgb(46, 10, 100);">
              <mat-icon class="iconsize">phone_in_talk</mat-icon>
              <h3 style="font-size: 20px;text-align: center;margin-bottom: 0px;">call</h3>
            </button>
          </div>
          <div fxFlex="30">
            <button fxLayout="row" (click)="composeEmail(data.smtpUsername)" fxLayoutAlign="center center" mat-button
              style=" width: 100%;  border:1px solid rgb(46, 10, 100);padding: 10px;border-radius: 10px;color: rgb(46, 10, 100);">
              <mat-icon class="iconsize">mail</mat-icon>
              <h3 style="font-size: 20px;text-align: center;margin-bottom: 0px;">Email</h3>
            </button>
          </div>
          <div fxFlex="40">
            <button fxLayout="row" (click)="whatsapp()" fxLayoutAlign="center center" mat-button
              style=" width: 100%; border:1px solid rgb(46, 10, 100);padding: 10px;border-radius: 10px;color: rgb(46, 10, 100);">
              <mat-icon class="iconsize">tap_and_play</mat-icon>
              <h3 style="font-size: 20px;text-align: center;margin-bottom: 0px;">whatsapp</h3>
            </button>
          </div>
          <div *ngIf="product['type'] !== 'Course' && product['type'] !== 'Variants Subscription'">
            <a title="Wishlist">
              <div class="icon-containers">
                <button *ngIf="!wishMapDisplay" color="warn"
                  style="width: 100%; border:1px solid rgb(46, 10, 100); padding: 10px; border-radius: 10px; color: rgb(46, 10, 100);"
                  mat-button matTooltip="Add to wishlist" (click)="addToWishList(product)">
                  <mat-icon style="margin-right: 0px;" class="iconsize">favorite_border</mat-icon>
                </button>

                <button *ngIf="wishMapDisplay" (click)="addToWishList(product)"
                  style="width: 100%; border:1px solid rgb(46, 10, 100); padding: 10px; border-radius: 10px; color: rgb(46, 10, 100);"
                  mat-button color="warn" aria-label="wishlist">
                  <mat-icon style="margin-right: 0px;" class="iconsize">favorite</mat-icon>
                </button>
              </div>
            </a>
          </div>

        </div>
      </div>

    </div>

  </div>




</div>


<div class="product-item  ext-center paddingmobile paddingtab" *ngIf="productLayoutType==16">

  <div
    style="background-color: white;border-radius: 20px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);border:1px solid rgb(232 232 232)"
    fxLayout="column">

    <div class="product-wrapper">

      <div class="sale-label1" style="z-index: 1000;" *ngIf="discountPercentage > 0 && discountPercentage < 100">

        <span> Sale </span>{{ discountPercentage | dynamicRound}}%
      </div>
      <div>
        <a [ngClass]="{ 'collection-banner': radius }" (click)="productShow(product)">
          <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
            [ngClass]="{ overlayProduct: (qty <= 0 || isInStock == 0) && (manageStock == 1 || isInStock == 0) }"
            (click)="productShow(product)"
            [ngStyle.lt-md]="{ visibility: isLoading ? 'hidden' : '', height: height == 0 ? 'auto' : heightMobile + 'px', width: '100%' }"
            [ngStyle.gt-sm]="{ visibility: isLoading ? 'hidden' : '', height: height == 0 ? 'auto' : height + 'px', width: '100%' }"
            [name]="name" [image]="image" style="border-top-left-radius: 20px; border-top-right-radius: 20px;">
        </a>
        <span *ngIf="product['type']!='Course'">
          <span *ngIf="this.product.type!='Booking'">
            <div *ngIf="outofstockEnabled==1">
              <div (click)="productShow(product)" class="outof1 centered2hala title center" fxLayout="row"
                fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
                <small fxLayoutAlign="center center" class="colorRed1">OUT OF STOCK</small>
              </div>
            </div>
          </span>
        </span>
      </div>

      <!-- Cart Button positioned at bottom right -->
      <!-- <div class="cart-button-wrapper">
        <button (click)="addToCart(product, 'cart', product.minSaleQty == 0 ? 1 : product.minSaleQty)" mat-icon-button>
          <mat-icon class="wish1">shopping_bag</mat-icon>
          <span *ngIf="qtyFormControl.value > 0" class="cart-items-count1">
            {{ qtyFormControl.value }}
          </span>
        </button>
      </div> -->
      <div class="cart-button-wrapper"
        [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
        <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
          [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
          [configproduct]="config" [type]="'cartIcon1'" [showCartIcon]="showCartIcon"
          [showCartIncremented]="showCartIncremented">
        </calsoft-controls>


      </div>
    </div>


    <div style="padding: 20px 10px;" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">

      <div class="productPrice1 padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start start">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div [style.-webkit-line-clamp]="data.categoryPageProductNameDisplayLine"
              [ngStyle.lt-md]="data.categoryPageProductNameDisplayLineMobHeight" style="font-size: 15px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;" [innerHTML]="name">

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <div [style.-webkit-line-clamp]="data.categoryPageProductNameDisplayLine"
              [ngStyle.lt-md]="data.categoryPageProductNameDisplayLineMobHeight" style="font-size: 19px; 
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;" [innerHTML]="name">

            </div>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>

      <div *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted fontsize-22px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>


            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted fontsize-22px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted fontsize-22px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

          </div>
        </div>
      </div>


      <ng-container *ngIf="calculateAvgRating >= 1; else emptyRatingBlock">
        <div [ngClass]="{
      padinf:
        configurableProductObject['type'] === 'Configurable' &&
        configurableProductObject['configurableProductDropdown'] != null
    }" class="padding-rl10" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div class="review-Rating1 E_uFuv">
            <ng-container *ngFor="let star of stars1; let i = index">
              <mat-icon class="star-icon" [ngClass]="{
            'filled-star':
              getStarIcon(i) === 'star' || getStarIcon(i) === 'star_half',
            'empty-star': getStarIcon(i) === 'star_border'
          }">
                {{ getStarIcon(i) }}
              </mat-icon>
            </ng-container>
          </div>
          <!-- <div class="margin">
            ({{ averageRating }})
          </div> -->
        </div>
      </ng-container>

      <ng-template #emptyRatingBlock>
        <div class="padding-rl10" style="height: 24px;"></div> <!-- Empty space fallback -->
      </ng-template>



      <div
        style="color: #878787;font-size: 15px;text-align: start; display: -webkit-box; -webkit-box-orient: vertical;overflow: hidden;-webkit-line-clamp: 1;"
        class="padding-rl10">
        <!-- {{ details }} -->
        {{shortDescription}}
      </div>

    </div>

  </div>

</div>

<div class="product-item  ext-center paddingmobile paddingtab" *ngIf="productLayoutType==17">

  <div
    style="background-color: white;border-radius: 20px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);border: 1px solid #d9d3d3;"
    fxLayout="row" fxLayout.xs="column" fxLayout.lt-md="column" fxLayout.lt-lg="column"
    fxLayoutAlign="space-between start">

    <div fxFlex="42%">
      <a [ngClass]="{ 'collection-banner': radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'100%':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'100%':width+'px'}"
          [name]="name" [image]="image" class="borderradius">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof1 centered3hala title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed1">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>

    </div>

    <div fxFlex style="padding: 10px;width: 100%;" fxLayout="column" fxLayoutGap="5px">

      <div class="productPrice1 padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start start">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div [style.-webkit-line-clamp]="data.categoryPageProductNameDisplayLine"
              [ngStyle.lt-md]="data.categoryPageProductNameDisplayLineMobHeight" style="font-size: 19px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;" [innerHTML]="name">

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <div [style.-webkit-line-clamp]="data.categoryPageProductNameDisplayLine"
              [ngStyle.lt-md]="data.categoryPageProductNameDisplayLineMobHeight" style="font-size: 15px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;" [innerHTML]="name">

            </div>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>

      <div *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted fontsize-22px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price"
                class="old-price text-strike text-muted fontsize-22px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label fontsize-22px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted fontsize-22px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>

          </div>
        </div>
      </div>


      <ng-container *ngIf="calculateAvgRating >= 1; else emptyRatingBlock">
        <div [ngClass]="{
      padinf:
        configurableProductObject['type'] === 'Configurable' &&
        configurableProductObject['configurableProductDropdown'] != null
    }" class="padding-rl10" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div class="review-Rating1 E_uFuv">
            <ng-container *ngFor="let star of stars1; let i = index">
              <mat-icon class="star-icon" [ngClass]="{
            'filled-star':
              getStarIcon(i) === 'star' || getStarIcon(i) === 'star_half',
            'empty-star': getStarIcon(i) === 'star_border'
          }">
                {{ getStarIcon(i) }}
              </mat-icon>
            </ng-container>
          </div>
          <!-- <div class="margin">
            ({{ averageRating }})
          </div> -->
        </div>
      </ng-container>

      <ng-template #emptyRatingBlock>
        <div class="padding-rl10" style="height: 24px;"></div> <!-- Empty space fallback -->
      </ng-template>



      <div
        style="color: #878787;font-size: 15px;text-align: start; display: -webkit-box; -webkit-box-orient: vertical;overflow: hidden;-webkit-line-clamp: 1;"
        class="padding-rl10">
        <!-- {{ details }} -->
        {{shortDescription}}
      </div>


      <!-- <div class="halameatcart">

        <a title="AddTocart">
          <div class="icon-containers">
            <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
              [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
              [configproduct]="config" [type]="'cartIcon1'" [showCartIcon]="showCartIcon"
              [showCartIncremented]="showCartIncremented">
            </calsoft-controls>
            <mat-icon class="wish">shopping_cart</mat-icon>
          </div>

        </a>

      </div> -->

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

        <div class="halameatcart">

          <a title="AddTocart">
            <div class="icon-containers">
              <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
                [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
                [configproduct]="config" [type]="'cartIcon1'" [showCartIcon]="showCartIcon"
                [showCartIncremented]="showCartIncremented">
              </calsoft-controls>
              <!-- <mat-icon class="wish">shopping_cart</mat-icon> -->
            </div>

          </a>

        </div>

        <!-- <button fxHide.lt-md style="width: 200px;border-radius: 50px;color: white;height:100%;" class="primary"
          mat-flat-button matTooltip="Add to cart" (click)="gotoCartNew()">
          Add To Cart
        </button> -->

        <calsoft-controls (formStatus)="onFormStatusChange($event)" [data]="data"
          *ngIf="(qty>0 && isInStock==1)||(manageStock==0);" [productCustomOption]="productCustomOption"
          [coversionTrackingIdGa]="coversionTrackingIdGa" [productOption]="salesFlatQuoteItemOption"
          [product]="configProductSelected" [configproduct]="product" [type]="'halacart1'" [buttonArray]="buttonArray"
          [configproduct]="product">
        </calsoft-controls>

      </div>

    </div>

  </div>

</div>


<div class="product-card-wrapper product-item" style="cursor: pointer;" *ngIf="productLayoutType==18">
  <div class="image-wrapper">
    <!-- Discount badge -->
    <div class="discount-badge" *ngIf="discountPercentage > 0 && discountPercentage < 100">
      {{ discountPercentage | dynamicRound }}% OFF
    </div>


    <div class="add-btn"
      *ngIf="!((product.qty <= 0 || product.isInStock == 0) && (product.manageStock == 1 || product.isInStock == 0))">
      <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
        [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
        [configproduct]="config" [type]="'cartIcon2'" [showCartIcon]="showCartIcon"
        [showCartIncremented]="showCartIncremented">
      </calsoft-controls>
    </div>

    <!-- Product Image -->
    <figure class="product-media">

      <a [ngClass]="{ 'collection-banner': !radius }" style="border-radius: 10px;" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>

    </figure>



    <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

      <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
        [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
        <div fxLayout="row">
          <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

            <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

          </div>
          <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
            alt="prescriptionRequired">
        </div>

      </div>

      <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
        [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
        <div fxLayout="row">
          <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
            [type]="'productsNew'"></calsoft-translator>
          <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
            alt="prescriptionRequired">
        </div>
      </div>



    </div>




    <div class="product-details2" *ngIf="this.data.disablePrice==0">
      <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
        <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
          fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

          <span *ngIf="displayMrpPrice">
            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b>MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ price | currencyConvert }}{{units}}
              </span>
            </span>
          </span>

          <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
            <span *ngIf="displayMrpPrice">
              <b>MRP :</b>
            </span>
            <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
          </span>

          <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
            <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
          </span>

          <span *ngIf="!displayMrpPrice">
            <span *ngIf="specialPrice > 0 && specialPrice != price" class="old-price text-strike text-muted font-16px">
              {{ price | currencyConvert }}{{units}}
            </span>
          </span>



        </div>

        <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
          fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

          <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
            <span *ngIf="displayMrpPrice">
              <b>MRP :</b>
            </span>
            <b> {{ price | currencyConvert }}{{units}}</b>
          </span>

          <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
            <b> {{ specialPrice | currencyConvert }}{{units}}</b>
            <span *ngIf="displayMrpPrice">
              (incl. of tax)
            </span>
          </span>

          <span *ngIf="specialPrice > 0 && specialPrice != price">
            <b *ngIf="displayMrpPrice">MRP :</b>
            <span class="old-price text-strike text-muted font-16px">
              {{ price | currencyConvert }}{{units}}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="product-item  ext-center" *ngIf="productLayoutType==19">

  <div class="product border-color-effect" style="border-radius: 15px;">
    <div class="discount-badge" *ngIf="discountPercentage > 0 && discountPercentage < 100">{{ discountPercentage |
      dynamicRound}}% </div>
    <figure class="product-media border-radius">

      <a [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>


      <div class="product-action-vertical1 product-action_2">

        <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
          [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
          [configproduct]="config " [type]="'type6addtocart'" [openlink]="product">
        </calsoft-controls>

      </div>

    </figure>

    <div
      style="color: #adadad;font-size: 13px;text-align: start; display: -webkit-box; -webkit-box-orient: vertical;overflow: hidden;-webkit-line-clamp: 1;padding-top: 10px;"
      class="padding-rl10" *ngIf="shortDescription">
      {{shortDescription}}
    </div>
    <div *ngIf="!shortDescription" style="padding-top: 10px;">&#160;</div>

    <!-- <div class="padding-rl10" *ngIf="outofstockEnabled!=1" style="text-align: start; display: -webkit-box; -webkit-box-orient: vertical;overflow: hidden;-webkit-line-clamp: 1;">
            <span class="stockmsg">In Stock</span>
          </div> -->

    <div class="product-details">


      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">


        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>

      </div>

    </div>

    <div class="price-cart-row">
      <div>
        <div [ngClass]="{
        padinf:
          configurableProductObject['type'] == 'Configurable' &&
          configurableProductObject['configurableProductDropdown'] != null
      }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
          fxLayoutGap="10px">
          <div class="review-Rating E_uFuv">
            {{ calculateAvgRating | number: "1.1-1" }}

            <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
          </div>
          <div>
            &#40;<span>{{ averageRating }}</span>&#41;
          </div>
        </div>
        <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
          style="padding-bottom: 20px"></div>

        <div *ngIf="showConfigurableDropdown == 1">

          <ng-container *ngIf="!showNewConfig; else newconfig">
            <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
        configurationDropDownList | keyvalue">
              <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
                <mat-label style="font-size: 12px">
                  {{ item.key.replace('_', ' ') }}
                </mat-label>
                <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                  (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                  [formControl]="dropDownValue">
                  <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                    {{ object | splitbyHash }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-template #newconfig>

            <div class="padding-rl10 A" fxLayout="row">
              <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
                <mat-label style="font-size: 12px">
                  {{configurationDropDownList[0].key}}
                </mat-label>
                <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                  <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')"
                    [value]="item.value" *ngFor="let item of configurationDropDownList;let i=index;">
                    {{item.value}}
                  </mat-option>
                </mat-select>

              </mat-form-field>
            </div>

            <div class="padding-rl10 A" fxLayout="row">
              <mat-form-field style="
          font-size: 10px;
          height: 54px;
          padding: 0px;
          margin: 0px;
          padding-bottom: 0px;
        " appearance="outline" fxFlex="100">
                <mat-label style="font-size: 12px">
                  {{configurationDropDownList[0]
                  ['recursuive'][0].key}}

                </mat-label>
                <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                .recursuive[secondIndex].value" [disableOptionCentering]="true">
                  <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                    [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
         ['recursuive'];let j=index;">
                    {{item1.value}}
                  </mat-option>
                </mat-select>


              </mat-form-field>
            </div>


          </ng-template>
        </div>

        <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
          <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
            <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
              fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

              <span *ngIf="displayMrpPrice">
                <span *ngIf="specialPrice > 0 && specialPrice != price">
                  <b>MRP :</b>
                  <span class="old-price text-strike text-muted " style="font-size: 16px;">
                    {{ price | currencyConvert }}{{units}}
                  </span>
                </span>
              </span>

              <span class="new-price123 price-label mrptag" *ngIf="specialPrice <= 0">
                <span *ngIf="displayMrpPrice">
                  <b>MRP :</b>
                </span>
                <b> {{ price | currencyConvert }}{{units}}</b> (incl. of tax)
              </span>

              <span class="new-price123 price-label mrptag" *ngIf="specialPrice > 0">
                <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
              </span>

              <span *ngIf="!displayMrpPrice">
                <span *ngIf="specialPrice > 0 && specialPrice != price" class="old-price text-strike text-muted ">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>

            </div>

            <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)"
              class="pointer padding-rl10" fxLayout="row" fxLayoutGap="10px"
              fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b *ngIf="displayMrpPrice">MRP :</b>
                <span class="old-price text-strike text-muted " style="font-size: 16px;">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>

              <span class="new-price123 price-label mrptag" *ngIf="specialPrice <= 0">
                <span *ngIf="displayMrpPrice">
                  <b>MRP :</b>
                </span>
                <b> {{ price | currencyConvert }}{{units}}</b>
              </span>

              <span class="new-price123 price-label mrptag" *ngIf="specialPrice > 0">
                <b> {{ specialPrice | currencyConvert }}{{units}}</b>
                <span *ngIf="displayMrpPrice">
                  (incl. of tax)
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cartnewbtn">
      <ng-container *ngIf="configProductSelected?.qty > 0; else emptyBlock"  style="height: 35px;">
        <calsoft-controls [product]="configProductSelected" [data]="data" [variant1Name]="variant1Name"
          [variant2Name]="variant2Name" [variant1Value]="variant1Value" [variant2Value]="variant2Value"
          [configproduct]="config" [type]="'newAddTocart2'" [showCartIcon]="showCartIcon"
          [showCartIncremented]="showCartIncremented" [paddingbtn]="'1'">
        </calsoft-controls>
      </ng-container>

      <ng-template #emptyBlock>
       <div class="padding-rl10" style="height: 35px;"></div>
      </ng-template>
    </div>
  </div>

</div>


<!-- gold design product type  -->
<div class="product-item  ext-center" style="border: 1px solid var(--primary-color);border-radius: 10px" 
*ngIf="productLayoutType==20">

  <div class="product" style="border-radius: 10px;margin-bottom: 0px;">
    <figure class="product-media">

      <a style="border-top-right-radius: 10px;border-top-left-radius: 10px;" [ngClass]="{ 'collection-banner': !radius }" (click)="productShow(product)">
        <img onerror="this.src='assets/images/products/placeholder.jpg';" [src]="image" [offset]="100" [alt]="name"
          [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }"
          class="padding-10" (click)="productShow(product)"
          [ngStyle.lt-md]="{visibility:isLoading?'hidden':'',height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}"
          [ngStyle.gt-sm]="{visibility:isLoading?'hidden':'',height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}"
          [name]="name" [image]="image" class="pointer">
      </a>
      <span *ngIf="product['type']!='Course'">
        <span *ngIf="this.product.type!='Booking'">
          <div *ngIf="outofstockEnabled==1">
            <div (click)="productShow(product)" class="outof centered1 title center" fxLayout="row"
              fxLayoutAlign="center center" *ngIf="(qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0)">
              <small fxLayoutAlign="center center" class="colorRed">OUT OF STOCK</small>
            </div>
          </div>
        </span>
      </span>


      <div class="product-action-vertical1 product-action_2">

        <calsoft-controls [data]="data" [variant1Name]="variant1Name" [variant2Name]="variant2Name"
          [variant1Value]="variant1Value" [variant2Value]="variant2Value" [product]="configProductSelected"
          [configproduct]="config " [type]="'type5addtocart'">
        </calsoft-controls>

      </div>



    </figure>

    <div class="product-details" fxLayout="column" fxLayoutAlign="space-between start">
      <div class="productPrice padding-rl10" (click)="productShow(product)" fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}" fxFlex>
          <div fxLayout="row">
            <div class="truncate-text" [fxFlex]="prescriptionRequired?96:100">

              <calsoft-translator [translateValue]="name" [data]="data" [type]="'products'"></calsoft-translator>

            </div>
            <img fxFlex height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>

        </div>

        <div fxFlex *ngIf="displayNameFully" [style.height]="data.categoryPageProductNameHeight"
          [ngStyle.lt-md]="{ 'height': categoryPageProductNameMobHeight}">
          <div fxLayout="row">
            <calsoft-translator [fxFlex]="prescriptionRequired?96:100" [translateValue]="name" [data]="data"
              [type]="'productsNew'"></calsoft-translator>
            <img height="27px" src="assets/images/rx.svg" style="margin-bottom:0px" *ngIf="prescriptionRequired"
              alt="prescriptionRequired">
          </div>
        </div>



      </div>


      <div [ngClass]="{
        padinf:
          configurableProductObject['type'] == 'Configurable' &&
          configurableProductObject['configurableProductDropdown'] != null
      }" class="padding-rl10" *ngIf="averageRating >= 1" fxLayout="row" fxLayoutAlign="start center"
        fxLayoutGap="10px">
        <div class="review-Rating E_uFuv">
          {{ calculateAvgRating | number: "1.1-1" }}

          <span class="material-icons f11" style="font-size: 15px;"> star_rate </span>
        </div>
        <div>
          &#40;<span>{{ averageRating }}</span>&#41;
        </div>
      </div>
      <div [ngClass]="{ overlayProduct: qty <= 0 && manageStock == 1 }" *ngIf="averageRating == 0"
        style="padding-bottom: 20px"></div>

      <div *ngIf="showConfigurableDropdown == 1">

        <ng-container *ngIf="!showNewConfig; else newconfig">
          <div class="padding-rl10 A" fxLayout="row" *ngFor="let item of 
        configurationDropDownList | keyvalue">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{ item.key.replace('_', ' ') }}
              </mat-label>
              <mat-select style="padding-bottom: 0.34375em; padding-top: 5px"
                (selectionChange)="getConfigProductId($event.value)" [disableOptionCentering]="true"
                [formControl]="dropDownValue">
                <mat-option style="font-size: 14px" [value]="object" *ngFor="let object of item.value">
                  {{ object | splitbyHash }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-template #newconfig>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
              font-size: 10px;
              height: 54px;
              padding: 0px;
              margin: 0px;
              padding-bottom: 0px;
            " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0].key}}
              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')" [value]="item.value"
                  *ngFor="let item of configurationDropDownList;let i=index;">
                  {{item.value}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="padding-rl10 A" fxLayout="row">
            <mat-form-field style="
          font-size: 10px;
          height: 54px;
          padding: 0px;
          margin: 0px;
          padding-bottom: 0px;
        " appearance="outline" fxFlex="100">
              <mat-label style="font-size: 12px">
                {{configurationDropDownList[0]
                ['recursuive'][0].key}}

              </mat-label>
              <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                .recursuive[secondIndex].value" [disableOptionCentering]="true">
                <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                  [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
         ['recursuive'];let j=index;">
                  {{item1.value}}
                </mat-option>
              </mat-select>


            </mat-form-field>
          </div>


        </ng-template>
      </div>

      <div style="padding-bottom: 10px;" *ngIf="this.data.disablePrice==0">
        <div [ngClass]="{ overlayProduct: (qty <= 0||isInStock==0) && (manageStock == 1||isInStock==0) }">
          <div *ngIf="inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price">
                <b>MRP :</b>
                <span class="old-price text-strike text-muted font-16px">
                  {{ price | currencyConvert }}{{units}}
                </span>
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b *ngIf="liveGoldRate!=0"> {{ finalPrice | currencyConvert }}{{units}}</b> (incl. of tax)
               <b *ngIf="liveGoldRate==0"> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b> (incl. of tax)
            </span>

            <span *ngIf="!displayMrpPrice">
              <span *ngIf="specialPrice > 0 && specialPrice != price "
                class="old-price text-strike text-muted font-16px">
                {{ finalPrice | currencyConvert }}{{units}}
              </span>
            </span>



          </div>

          <div *ngIf="!inclTaxEnabled" class="padding-rl10" (click)="productShow(product)" class="pointer padding-rl10"
            fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="{{ productPriceCenter ? 'center' : 'start' }}">

            <span *ngIf="specialPrice > 0 && specialPrice != price">
              <b *ngIf="displayMrpPrice">MRP :</b>
              <span class="old-price text-strike text-muted font-16px">
                {{ finalPrice | currencyConvert }}{{units}}
              </span>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice <= 0">
              <span *ngIf="displayMrpPrice">
                <b>MRP :</b>
              </span>
              <b *ngIf="liveGoldRate!=0"> {{ finalPrice | currencyConvert }}{{units}}</b>
              <b *ngIf="liveGoldRate==0"> {{ price | currencyConvert }}{{units}}</b>
            </span>

            <span class="new-price123 price-label font-16px" *ngIf="specialPrice > 0">
              <b> {{ specialPrice | currencyConvert }}{{units}}</b>
              <span *ngIf="displayMrpPrice">
                (incl. of tax)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>